import { render, staticRenderFns } from "./ChatAttachmentBar.vue?vue&type=template&id=a940bfb2&scoped=true"
import script from "./ChatAttachmentBar.vue?vue&type=script&lang=js"
export * from "./ChatAttachmentBar.vue?vue&type=script&lang=js"
import style0 from "./ChatAttachmentBar.vue?vue&type=style&index=0&id=a940bfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a940bfb2",
  null
  
)

export default component.exports